<template>
  <div class="calendar-modal">
    <div class="calendar-header">
      <h2>Calendario de ocupación</h2>
      <p>Visualiza las horas ocupadas por mesa para esta semana.</p>
    </div>
    <full-calendar :options="calendarOptions" />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/init';
import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

export default {
  name: 'ReservationCalendar',
  components: {
    FullCalendar
  },
  setup() {
    const reservations = ref([]);

    const calendarOptions = ref({
      plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
      initialView: 'timeGridWeek',
      timeZone: 'America/Puerto_Rico',
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'timeGridDay,timeGridWeek,dayGridMonth'
      },
      slotMinTime: '11:00:00',
      slotMaxTime: '22:00:00',
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      },
      eventTimeFormat: {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      },
      events: [],
    });

    onMounted(() => {
      onSnapshot(collection(db, 'reservations'), (snapshot) => {
        reservations.value = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        updateCalendarEvents();
      });
    });

    const updateCalendarEvents = () => {
      calendarOptions.value.events = reservations.value.map(res => ({
        id: res.id,
        title: `${res.tableNumber || 'Sin mesa'} · ${res.name} · ${res.people}p`,
        start: `${res.date}T${res.time}`,
        end: `${res.date}T${calculateEndTime(res.time)}`,
        backgroundColor: res.status === 'confirmed' ? '#4ade80' : '#f97316',
        borderColor: 'transparent'
      }));
    };

    const calculateEndTime = (startTime) => {
      const [hour, minute] = startTime.split(':').map(Number);
      const date = new Date();
      date.setHours(hour, minute);
      date.setMinutes(date.getMinutes() + 120);
      const endHour = String(date.getHours()).padStart(2, '0');
      const endMinute = String(date.getMinutes()).padStart(2, '0');
      return `${endHour}:${endMinute}`;
    };

    return {
      calendarOptions,
    };
  }
};
</script>

<style scoped>
.calendar-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.calendar-header h2 {
  margin: 0;
}

.calendar-header p {
  margin: 4px 0 0;
  color: #6b7280;
}
</style>
